import React, { createContext, useContext } from 'react';
import { ElementType } from '../../types/api/ElementType';

type BlockContextProps = {
  elementType: ElementType | undefined;
  uuid: string | undefined;
};

const BlockContext = createContext<BlockContextProps>({
  elementType: undefined,
  uuid: undefined,
});

export const useBlockContext = () => useContext(BlockContext);

export const withBlockContext = <P extends object>(Component: React.ComponentType<P>) => {
  // do not directly return the HOC:
  // react requires the assignment to the variable to get the displayName of the Component
  function WithBlockContext(props: P) {
    return <Component {...useBlockContext()} {...props} />;
  }
  return WithBlockContext;
};

export default BlockContext;
